<template>
  <div class="ViewApproveAccount" v-loading="loadingPage">
    <HeaderPage>
      <el-button @click="approve" style="height: 44px; margin-left: 1rem" type="success" >Aprovar</el-button>
      <el-button @click="refuse" style="height: 44px; margin-left: 1rem" type="danger" >Recusar</el-button>
    </HeaderPage>
    <el-card shadow="never">
      <el-descriptions :title="'Detalhes do checklist ID: '+dados.data.id" :column="3" border direction="vertical">
        <template slot="extra">
          <TagStatus :status="dados.status" />
        </template>
      </el-descriptions>
      <el-descriptions :column="3" border direction="vertical">
        <el-descriptions-item label="Nome completo">{{dados.data.name}}</el-descriptions-item>
        <el-descriptions-item label="Data de nascimento">{{ moment(dados.data.birthday).format('DD/MM/YYYY') }}</el-descriptions-item>
        <el-descriptions-item label="Tipo de pessoa">{{dados.data.type_person}}</el-descriptions-item>
        <el-descriptions-item label="CPF">{{dados.data.cpf}}</el-descriptions-item>
        <el-descriptions-item label="RG">{{dados.data.rg}}</el-descriptions-item>
        <el-descriptions-item label="E-mail">{{dados.data.contact.email}}</el-descriptions-item>
        <el-descriptions-item label="Telefone">{{dados.data.contact.phone}}</el-descriptions-item>
        <el-descriptions-item>
        </el-descriptions-item>
      </el-descriptions>
      <br><br>
      <el-descriptions title="Empresa" :column="2" border direction="vertical">
        <el-descriptions-item label="Nome do estabelecimento">{{dados.data.name_store}}</el-descriptions-item>
        <el-descriptions-item label="Limite">{{ dados.data.limit }}</el-descriptions-item>
      </el-descriptions>
      <br><br>
      <el-alert v-if="dados.data.address === null" title="Endereço não informado" :closable="false" type="warning" style="margin-bottom: 25px;" />
      <el-descriptions title="Endereço" v-else :column="3" border direction="vertical">
        <el-descriptions-item label="CEP">{{dados.data.address.postal_code}}</el-descriptions-item>
        <el-descriptions-item label="Rua">{{ dados.data.address.street }}</el-descriptions-item>
        <el-descriptions-item label="Nº">{{ dados.data.address.number }}</el-descriptions-item>
        <el-descriptions-item label="Bairro">{{ dados.data.address.neighborhood }}</el-descriptions-item>
        <el-descriptions-item label="Bairro">{{ dados.data.address.neighborhood }}</el-descriptions-item>
        <el-descriptions-item label="Cidade">{{ dados.data.address.city }} - {{ dados.data.address.state }}</el-descriptions-item>
      </el-descriptions>
      <br><br>
      <el-alert v-if="dados.data.bank_account[0] === undefined" title="Dados Bancários não informado" :closable="false" type="warning" style="margin-bottom: 25px;" />
      <el-descriptions title="Dados bancários" v-else :column="3" border direction="vertical">
        <el-descriptions-item label="Tipo de conta" span="3">
          <span v-if="dados.data.bank_account[0].type === 'payment'">Conta de pagamentos de limite</span>
          <span v-if="dados.data.bank_account[0].type === 'savings'">Conta Poupança</span>
          <span v-if="dados.data.bank_account[0].type === 'checking'">Conta corrente</span>
        </el-descriptions-item>
        <el-descriptions-item label="Banco">{{ '-' }}</el-descriptions-item>
        <el-descriptions-item label="Agência">{{ dados.data.bank_account[0].routing_number }}</el-descriptions-item>
        <el-descriptions-item label="Conta">{{ dados.data.bank_account[0].account_number }}</el-descriptions-item>
      </el-descriptions>
      <br><br>
      <el-alert v-if="dados.data.document[0] === undefined" title="Documentos não informado" :closable="false" type="warning" style="margin-bottom: 25px;" />
      <el-descriptions title="Documentos" v-else v-for="doc in dados.data.document" :key="doc.id" :column="4" border direction="vertical">
        <el-descriptions-item label="Tipo">
          <span v-if="doc.type === 'document_photo'">Documeno com foto</span>
          <span v-if="doc.type === 'term_lgpd'">Termo LGPD</span>
          <span v-if="doc.type === 'invoice_limit'">Documento para aumento de limite</span>
          <span v-if="doc.type === 'income_voucher'">Comprovante de renda</span>
          <span v-if="doc.type === 'business_activity'">Atividade empresarial</span>
          <span v-if="doc.type === 'cnpj_card'">Cartão CNPJ</span>
        </el-descriptions-item>
        <el-descriptions-item label="Documento">
          <el-button @click="openUrl(doc.url)" size="small">Download</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="Documento">
          {{moment(doc.created_at).format('DD/MM/YY HH:mm')}}
        </el-descriptions-item>
        <el-descriptions-item label="Status">
          <tagStatus :status="doc.status" />
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import {getAprovarContas, getBankDados, postAprovarContas, postRefuseCR} from "@/app/domains/Records/services";
import {makeErrorFilds} from "@/app/plugins/utils";
import HeaderPage from "@/app/components/HeaderPage";
import SelectSearchMarketplace from "@/app/components/Marketplace/SelectSearchMarketplace";
import SearchProviders from "@/app/components/Providers/SearchProviders";
import SelectSearchModeloEquipamento from "@/app/components/ModeloEquipamento/SelectSearchModeloEquipamento";
import {getBank} from "@/app/domains/Config/services";
import TagStatus from "@/app/components/Table/TagStatus";

export default {
  name: "ViewApproveAccount",
  components: {
    HeaderPage,
    TagStatus,
  },
  data () {
    return {
      loadingPage: false,
      dados: {
        person: {},
        data: {
          contact: {},
          address: {},
          bank_account: [],
          document: [],
        },
      }
    }
  },
  methods: {
    init() {
      this.listDados()
    },
    openUrl(url) {
      window.open(url, '_blank')
    },
    async listDados () {
      this.loadingPage = true
      try {
        let response = await getAprovarContas(`/${this.$route.params.id}`)
        this.dados = response.data
        
      } catch (e) {
        this.$message({
          showClose: true,
          message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
          type: 'error'
        })
      } finally {
        this.loadingPage = false
      }
    },
    refuse () {
      this.$confirm('Deseja realmente recusar está conta?', 'Atenção', {
        center: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning'
      }).then(async () => {
        this.loadingPage = true
        try {
          let response = await postRefuseCR(this.$route.params.id)
          await this.$router.push({name: 'records.approveAccount.index'})
          this.$message({
            showClose: true,
            message: 'Conta atualizada!',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false
        }
      }).catch(() => {});
    },
    approve () {
      
      this.$confirm('Deseja realmente aprovar está conta?', 'Atenção', {
        center: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        type: 'warning'
      }).then(async () => {
        this.loadingPage = true
        try {
          let response = await postAprovarContas(this.$route.params.id)
          await this.$router.push({name: 'records.approveAccount.index'})
          this.$message({
            showClose: true,
            message: 'Conta atualizada!',
            type: 'success'
          })
        } catch (e) {
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: 'error'
          })
        } finally {
          this.loadingPage = false
        }
      }).catch(() => {});
    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style scoped>

</style>
